import React from 'react';
import Header from '../common/header';
import Footer from '../common/footer';
import SocialMediaPageHeader from '../layout/socialmedia/socialPageHead';
import SocialMediaPage from '../layout/socialmedia/socialMediaPage';



function SocialMedia(){
    return(
        <div>
            <Header/>
            <br/>
           <SocialMediaPageHeader/>
           <br/>
           <SocialMediaPage/>
            <br/>
            <Footer/>
        </div>
    )
}
export default SocialMedia;
